<div class="catalog-page">
  <div class="common-container">
    <!-- Editor choice -->
    <h2 class="common-section-title common-section-title--catalog">
      {{ lg.catalogPage.headings.popularBeats }}
    </h2>
    <section class="catalog-page__popular-tracks">
      <bmcore-editor-choice></bmcore-editor-choice>
    </section>

    <!-- Tracks / producers categories (tabs) -->
    <h2 class="common-section-title common-section-title--catalog">
      {{ lg.catalogPage.headings.allBeats }}
    </h2>
    <div class="catalog-page__tabs">
      <div
        class="catalog-page__tabs-item"
        [ngClass]="{ 'catalog-page__tabs-item--active': searchCategory === SearchBy.Beats && 'active category' }"
        (click)="changeSearchCategory('tracks')"
      >
        <p>{{ lg.catalogPage.tabs.tracks }}</p>
      </div>
      <div
        class="catalog-page__tabs-item"
        [ngClass]="{ 'catalog-page__tabs-item--active': searchCategory === SearchBy.Beatmakers && 'active category' }"
        (click)="changeSearchCategory('producers')"
      >
        <p>{{ lg.catalogPage.tabs.producers }}</p>
      </div>
    </div>

    <!-- Tracks block -->
    @if (searchCategory === SearchBy.Beats) {
      <div class="catalog-page_content">
        <bmcore-tracks-block
          [appType]="appType"
          [isTracksPage]="true"
          [isShowTracksAllBeatmakers]="true"
          [pageSize]="20"
          [pagesWithFilter]="'production-mode'"
          [showVerificationIcon]="showVerificationIcon"
        >
        </bmcore-tracks-block>
      </div>
    }

    <!-- Producers block -->
    @if (searchCategory === SearchBy.Beatmakers) {
      <div class="catalog-page_content">
        <bmcore-producers-block></bmcore-producers-block>
      </div>
    }
  </div>
</div>
